/**
 * Local-only demo sessions shared by Dashboard, Candidates, Interviews, Analytics.
 * Toggle via USE_DEMO_DATA in src/data/demoMode.js.
 */

function daysAgo(n) {
  const d = new Date();
  d.setHours(12, 0, 0, 0);
  d.setDate(d.getDate() - n);
  return d.toISOString();
}

/** @deprecated Prefer DUMMY_CAMPAIGNS from campaignsDummyData (kept for import compatibility). */
export const DUMMY_CAMPAIGNS = [
  { id: "demo-camp-fe", name: "Senior Frontend Engineer", job_role: "Frontend", is_active: true },
  { id: "demo-camp-be", name: "Backend Engineer", job_role: "Backend", is_active: true },
  { id: "demo-camp-ds", name: "Data Scientist", job_role: "Data Science", is_active: true },
  { id: "demo-camp-pm", name: "Product Manager", job_role: "Product", is_active: false },
];

/** Diverse statuses, scores, recruiters, positions, and dates for filter demos. */
export const DUMMY_SESSIONS = [
  // ── Senior Frontend / Priya Sharma ──
  {
    id: "demo-s1",
    candidate_name: "Aarav Mehta",
    candidate_email: "aarav.mehta@example.com",
    campaign_id: "demo-camp-fe",
    campaign_name: "Senior Frontend Engineer",
    job_role: "Frontend",
    recruiter_name: "Priya Sharma",
    status: "completed",
    overall_score: 9.7,
    hiring_recommendation: "strong_yes",
    total_violations: 0,
    duration_seconds: 2400,
    created_at: daysAgo(2),
    started_at: daysAgo(2),
    completed_at: daysAgo(2),
    invite_sent_at: daysAgo(5),
  },
  {
    id: "demo-s2",
    candidate_name: "Neha Kapoor",
    candidate_email: "neha.kapoor@example.com",
    campaign_id: "demo-camp-fe",
    campaign_name: "Senior Frontend Engineer",
    job_role: "Frontend",
    recruiter_name: "Priya Sharma",
    status: "completed",
    overall_score: 7.2,
    hiring_recommendation: "yes",
    total_violations: 2,
    duration_seconds: 2100,
    created_at: daysAgo(5),
    started_at: daysAgo(5),
    completed_at: daysAgo(5),
    invite_sent_at: daysAgo(8),
  },
  {
    id: "demo-s3",
    candidate_name: "Rohan Iyer",
    candidate_email: "rohan.iyer@example.com",
    campaign_id: "demo-camp-fe",
    campaign_name: "Senior Frontend Engineer",
    job_role: "Frontend",
    recruiter_name: "Priya Sharma",
    status: "in_progress",
    overall_score: null,
    hiring_recommendation: null,
    total_violations: 1,
    duration_seconds: 600,
    created_at: daysAgo(0),
    started_at: daysAgo(0),
    completed_at: null,
    invite_sent_at: daysAgo(1),
  },
  {
    id: "demo-s4",
    candidate_name: "Ishita Bose",
    candidate_email: "ishita.bose@example.com",
    campaign_id: "demo-camp-fe",
    campaign_name: "Senior Frontend Engineer",
    job_role: "Frontend",
    recruiter_name: "Priya Sharma",
    status: "scheduled",
    overall_score: null,
    hiring_recommendation: null,
    total_violations: 0,
    duration_seconds: 0,
    created_at: daysAgo(1),
    started_at: null,
    completed_at: null,
    invite_sent_at: daysAgo(1),
  },

  // ── Backend / Marcus Chen ──
  {
    id: "demo-s5",
    candidate_name: "Kabir Singh",
    candidate_email: "kabir.singh@example.com",
    campaign_id: "demo-camp-be",
    campaign_name: "Backend Engineer",
    job_role: "Backend",
    recruiter_name: "Marcus Chen",
    status: "completed",
    overall_score: 9.6,
    hiring_recommendation: "strong_yes",
    total_violations: 0,
    duration_seconds: 2700,
    created_at: daysAgo(3),
    started_at: daysAgo(3),
    completed_at: daysAgo(3),
    invite_sent_at: daysAgo(6),
  },
  {
    id: "demo-s6",
    candidate_name: "Ananya Reddy",
    candidate_email: "ananya.reddy@example.com",
    campaign_id: "demo-camp-be",
    campaign_name: "Backend Engineer",
    job_role: "Backend",
    recruiter_name: "Marcus Chen",
    status: "completed",
    overall_score: 5.1,
    hiring_recommendation: "no",
    total_violations: 4,
    duration_seconds: 1800,
    created_at: daysAgo(7),
    started_at: daysAgo(7),
    completed_at: daysAgo(7),
    invite_sent_at: daysAgo(10),
  },
  {
    id: "demo-s7",
    candidate_name: "Dev Patel",
    candidate_email: "dev.patel@example.com",
    campaign_id: "demo-camp-be",
    campaign_name: "Backend Engineer",
    job_role: "Backend",
    recruiter_name: "Marcus Chen",
    status: "terminated",
    overall_score: 3.2,
    hiring_recommendation: "no",
    total_violations: 14,
    duration_seconds: 900,
    created_at: daysAgo(4),
    started_at: daysAgo(4),
    completed_at: daysAgo(4),
    invite_sent_at: daysAgo(5),
  },
  {
    id: "demo-s8",
    candidate_name: "Maya Krishnan",
    candidate_email: "maya.krishnan@example.com",
    campaign_id: "demo-camp-be",
    campaign_name: "Backend Engineer",
    job_role: "Backend",
    recruiter_name: "Marcus Chen",
    status: "invited",
    overall_score: null,
    hiring_recommendation: null,
    total_violations: 0,
    duration_seconds: 0,
    created_at: daysAgo(2),
    started_at: null,
    completed_at: null,
    invite_sent_at: daysAgo(2),
  },

  // ── Data Scientist / Priya Sharma + Elena Vargas ──
  {
    id: "demo-s9",
    candidate_name: "Sanjay Nair",
    candidate_email: "sanjay.nair@example.com",
    campaign_id: "demo-camp-ds",
    campaign_name: "Data Scientist",
    job_role: "Data Science",
    recruiter_name: "Elena Vargas",
    status: "completed",
    overall_score: 8.4,
    hiring_recommendation: "yes",
    total_violations: 1,
    duration_seconds: 3000,
    created_at: daysAgo(6),
    started_at: daysAgo(6),
    completed_at: daysAgo(6),
    invite_sent_at: daysAgo(9),
  },
  {
    id: "demo-s10",
    candidate_name: "Pooja Desai",
    candidate_email: "pooja.desai@example.com",
    campaign_id: "demo-camp-ds",
    campaign_name: "Data Scientist",
    job_role: "Data Science",
    recruiter_name: "Elena Vargas",
    status: "completed",
    overall_score: 4.0,
    hiring_recommendation: "no",
    total_violations: 12,
    duration_seconds: 1500,
    created_at: daysAgo(9),
    started_at: daysAgo(9),
    completed_at: daysAgo(9),
    invite_sent_at: daysAgo(12),
  },
  {
    id: "demo-s11",
    candidate_name: "Vikram Rao",
    candidate_email: "vikram.rao@example.com",
    campaign_id: "demo-camp-ds",
    campaign_name: "Data Scientist",
    job_role: "Data Science",
    recruiter_name: "Priya Sharma",
    status: "completed",
    overall_score: 9.5,
    hiring_recommendation: "strong_yes",
    total_violations: 0,
    duration_seconds: 2600,
    created_at: daysAgo(11),
    started_at: daysAgo(11),
    completed_at: daysAgo(11),
    invite_sent_at: daysAgo(14),
  },
  {
    id: "demo-s12",
    candidate_name: "Lara Fernandes",
    candidate_email: "lara.fernandes@example.com",
    campaign_id: "demo-camp-ds",
    campaign_name: "Data Scientist",
    job_role: "Data Science",
    recruiter_name: "Elena Vargas",
    status: "in_progress",
    overall_score: null,
    hiring_recommendation: null,
    total_violations: 0,
    duration_seconds: 420,
    created_at: daysAgo(0),
    started_at: daysAgo(0),
    completed_at: null,
    invite_sent_at: daysAgo(3),
  },

  // ── Product Manager / Marcus Chen ──
  {
    id: "demo-s13",
    candidate_name: "Omar Hassan",
    candidate_email: "omar.hassan@example.com",
    campaign_id: "demo-camp-pm",
    campaign_name: "Product Manager",
    job_role: "Product",
    recruiter_name: "Marcus Chen",
    status: "completed",
    overall_score: 6.8,
    hiring_recommendation: "yes",
    total_violations: 3,
    duration_seconds: 2200,
    created_at: daysAgo(14),
    started_at: daysAgo(14),
    completed_at: daysAgo(14),
    invite_sent_at: daysAgo(18),
  },
  {
    id: "demo-s14",
    candidate_name: "Chloe Martin",
    candidate_email: "chloe.martin@example.com",
    campaign_id: "demo-camp-pm",
    campaign_name: "Product Manager",
    job_role: "Product",
    recruiter_name: "Elena Vargas",
    status: "scheduled",
    overall_score: null,
    hiring_recommendation: null,
    total_violations: 0,
    duration_seconds: 0,
    created_at: daysAgo(8),
    started_at: null,
    completed_at: null,
    invite_sent_at: daysAgo(8),
  },

  // Outside default 30-day window — use From/To presets to include these
  {
    id: "demo-s15",
    candidate_name: "Older Candidate",
    candidate_email: "older@example.com",
    campaign_id: "demo-camp-fe",
    campaign_name: "Senior Frontend Engineer",
    job_role: "Frontend",
    recruiter_name: "Priya Sharma",
    status: "completed",
    overall_score: 7.5,
    hiring_recommendation: "yes",
    total_violations: 0,
    duration_seconds: 2000,
    created_at: daysAgo(45),
    started_at: daysAgo(45),
    completed_at: daysAgo(45),
    invite_sent_at: daysAgo(50),
  },
  {
    id: "demo-s16",
    candidate_name: "Rahul Verma",
    candidate_email: "rahul.verma@example.com",
    campaign_id: "demo-camp-be",
    campaign_name: "Backend Engineer",
    job_role: "Backend",
    recruiter_name: "Elena Vargas",
    status: "completed",
    overall_score: 9.8,
    hiring_recommendation: "strong_yes",
    total_violations: 0,
    duration_seconds: 2500,
    created_at: daysAgo(1),
    started_at: daysAgo(1),
    completed_at: daysAgo(1),
    invite_sent_at: daysAgo(4),
  },
];

/** Logged-in admin display name (same source as AdminLayout sidebar). */
export function getLoggedInRecruiterName() {
  try {
    const raw = localStorage.getItem('admin');
    if (!raw) return '';
    const admin = JSON.parse(raw);
    return String(admin.full_name || admin.name || '').trim();
  } catch {
    return '';
  }
}

const DEMO_SESSIONS_FOR_CURRENT_RECRUITER = new Set(['demo-s1', 'demo-s5', 'demo-s9']);

/** Assign a few demo sessions to the logged-in recruiter so filtering returns data. */
export function withCurrentRecruiterInDemoSessions(sessions) {
  const name = getLoggedInRecruiterName();
  if (!name) return sessions.map((s) => ({ ...s }));
  return sessions.map((s) =>
    DEMO_SESSIONS_FOR_CURRENT_RECRUITER.has(s.id)
      ? { ...s, recruiter_name: name }
      : { ...s }
  );
}

/** Recruiter dropdown: session recruiters plus logged-in admin (always included). */
export function buildRecruiterOptions(sessions) {
  const map = new Map();
  (sessions || []).forEach((s) => {
    const name = (s.recruiter_name || '').trim();
    if (name) map.set(name, name);
  });
  const loggedIn = getLoggedInRecruiterName();
  if (loggedIn) map.set(loggedIn, loggedIn);
  return Array.from(map.values()).sort((a, b) => a.localeCompare(b));
}
